'use client';
import { InputIcon } from '../InputIcon/InputIcon.js';

var IDENT_INPUT = "Input";
var defaultProps = {
    size: "md1",
    icon: InputIcon,
    withBorder: true,
    mountIcon: true
};

export { IDENT_INPUT, defaultProps };
